import styled from 'styled-components'

export const Caixa = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  height: 36px;
  padding: 0 10px;
  border: 1px solid ${(props) => props.theme.colors.gray[200]};
  border-radius: 8px;
  background: #fff;
`

export const Grupo = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 0 7px;
  white-space: nowrap;
  background: transparent;
  cursor: pointer;
  border-radius: 6px;

  &:hover:not(:disabled) {
    background: ${(props) => props.theme.colors.gray[100]};
  }

  &:disabled {
    cursor: default;
    opacity: 0.55;
  }

  & + & {
    border-left: 1px solid ${(props) => props.theme.colors.gray[200]};
    padding-left: 11px;
  }
`

export const Ponto = styled.span`
  width: 8px;
  height: 8px;
  flex-shrink: 0;
  border-radius: 50%;
  background: ${(props) => props.$cor || props.theme.colors.gray[400]};
`

export const Numero = styled.strong`
  font-size: 14px;
  font-weight: 700;
  color: ${(props) => props.theme.colors.gray[800]};
  font-variant-numeric: tabular-nums;
`
